import moment from "moment"
import { useEffect, useState } from "react"
import { dictionaryCRUD } from "../../../../actions/dictionary"


export const DeathDetail = (props) => {

  const {data, step4, setStep4} = props

  const [death, setDeath] = useState(null)

  useEffect(() => {
    setTimeout(() => {
      dictionaryCRUD.loadDictionaryItemById(data.dictionary_death_causes).then((resp) => {
        setDeath(resp.data && resp.data.dictionary_item_name_en)
      })
    },500)
  },[data])

  return (
    <>
      <div>
        <div className="row">
            <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Death Date</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-email-input" value={data.death_date ? moment(data.death_date).format("D MMM, YYYY") : 'N/A'}  readOnly/>
                </div>
            </div>
            <div className="col-lg-6 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Death Causes</label>
                    <input type="text" className="form-control border-dashed" id="steparrow-gen-info-username-input" value={death ? (death).toUpperCase() : 'N/A'}  readOnly/>
                </div>
            </div>
        </div>
        <div className="row">
            <div className="col-lg-12 col-sm-12">
                <div className="mb-3">
                    <label className="form-label" >Description</label>
                    <textarea rows={5} className="form-control border-dashed" id="steparrow-gen-info-email-input" value={data.death_detail ? (data.death_detail).toUpperCase() : 'N/A'} readOnly/>
                </div>
            </div>
        </div>
      </div>
      <div class="d-flex align-items-start gap-3 mt-4">
          <button type="button" class="btn btn-light btn-label" onClick={() => setStep4(!step4)} ><i class="bi bi-chevron-double-left label-icon align-middle fs-16 me-2"></i> Previous</button>
      </div>
    </>
  )

}